import React,{ useEffect} from 'react';
import { FaqWrapper, FaqTitle, FaqCategory, SearchFaqBox } from './Faqs.style';
import { Accordion } from './Accordion';
import { faqData, faqDataInvestment, faqDataSafetySecurity, faqDataSavings, faqDataWithdrawals } from '../../data/faqData';

export const Faqs = () => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
    <FaqWrapper>
      <FaqTitle>Frequently Asked Questions</FaqTitle>

      <SearchFaqBox>
        <form action="">
          <input type="text" placeholder="Search for any question" />
        </form>
      </SearchFaqBox>

      <FaqCategory>General</FaqCategory>


    {
        faqData.map(data=>(
            <Accordion
            key={data.id}
            title={data.title}
            content={data.content}
            />
        ))
    } 
    </FaqWrapper>
    <FaqWrapper>
    <FaqCategory>Savings</FaqCategory>


    {
        faqDataSavings.map(data=>(
            <Accordion
            key={data.id}
            title={data.title}
            content={data.content}
            />
        ))
    } 
    </FaqWrapper>
    <FaqWrapper>
    <FaqCategory>Investment</FaqCategory>
    {
        faqDataInvestment.map(data=>(
            <Accordion
            key={data.id}
            title={data.title}
            content={data.content}
            />
        ))
    } 
    </FaqWrapper>
    <FaqWrapper>
    <FaqCategory>Safety and Security</FaqCategory>
    {
        faqDataSafetySecurity.map(data=>(
            <Accordion
            key={data.id}
            title={data.title}
            content={data.content}
            />
        ))
    } 
    </FaqWrapper>
    <FaqWrapper>
    <FaqCategory>Withdrawals</FaqCategory>
    {
        faqDataWithdrawals.map(data=>(
            <Accordion
            key={data.id}
            title={data.title}
            content={data.content}
            />
        ))
    } 
    </FaqWrapper>
    </>
  )
}
